// forEach method, could be shipped as part of an Object Literal/Module
function forEach(array, callback, scope) {
    var index = 0;
    for (index = 0; index < array.length; index += 1) {
        callback.call(scope, array[index], index); // passes back stuff we need
    }
}
function hasClass(el, className) {
    var regex = new RegExp('^' + className + '| +' + className, 'g');
    return el.className.match(regex);
}
function addClass(el, className) {
    // Return if it already has the className
    if (hasClass(el, className))
        return;
    el.className += ' ' + className;
}
function removeClass(el, className) {
    // Return if it doesn't already have the className
    if (!hasClass(el, className))
        return;
    var regex = new RegExp('^' + className + '| +' + className, 'g');
    el.className = el.className.replace(regex, '');
}
function toggleClass(el, className) {
    if (hasClass(el, className)) {
        removeClass(el, className);
    }
    else {
        addClass(el, className);
    }
}
function findPairingFromPairingTrigger(pairings, pairingTrigger) {
    var foundPairing = null;
    forEach(pairings, function (pairing) {
        if (pairing.trigger === pairingTrigger) {
            foundPairing = pairing;
        }
    });
    return foundPairing;
}
/**
 * See {@link https://stackoverflow.com/revisions/2117523/11 Stack Overflow}
 * An RFC4122 v4 compliant uuid solution
 */
function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
function init(groupedContent) {
    var triggers = groupedContent.triggers;
    var pairings = groupedContent.pairings;
    triggers.setAttribute('role', 'tablist');
    forEach(pairings, function (pairing, index) {
        pairing.trigger.setAttribute('role', 'tab');
        pairing.trigger.setAttribute('aria-controls', groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content');
        if (pairing.trigger.children.length > 0) {
            forEach(pairing.trigger.children, function (child) {
                child.setAttribute('tabIndex', '-1');
            });
        }
        if (hasClass(pairing.trigger, 'active')) {
            pairing.trigger.setAttribute('aria-selected', 'true');
            pairing.trigger.setAttribute('tabIndex', '0');
        }
        else {
            pairing.trigger.setAttribute('tabIndex', '-1');
        }
        pairing.content.id = groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content';
        pairing.content.setAttribute('role', 'tabpanel');
        if (!hasClass(pairing.content, 'active')) {
            pairing.content.setAttribute('aria-hidden', 'true');
        }
    });
}
function update(groupedContent) {
    var pairings = groupedContent.pairings;
    forEach(pairings, function (pairing) {
        pairing.trigger.removeAttribute('aria-selected');
        pairing.content.removeAttribute('aria-hidden');
        if (hasClass(pairing.trigger, 'active')) {
            pairing.trigger.setAttribute('aria-selected', 'true');
            pairing.trigger.setAttribute('tabIndex', '0');
        }
        else {
            pairing.trigger.setAttribute('tabIndex', '-1');
        }
        if (!hasClass(pairing.content, 'active')) {
            pairing.content.setAttribute('aria-hidden', 'true');
        }
    });
}
var a11y = {
    init: init,
    update: update,
};
var asyncGenerator = (function () {
    function AwaitValue(value) {
        this.value = value;
    }
    function AsyncGenerator(gen) {
        var front, back;
        function send(key, arg) {
            return new Promise(function (resolve, reject) {
                var request = {
                    key: key,
                    arg: arg,
                    resolve: resolve,
                    reject: reject,
                    next: null,
                };
                if (back) {
                    back = back.next = request;
                }
                else {
                    front = back = request;
                    resume(key, arg);
                }
            });
        }
        function resume(key, arg) {
            try {
                var result = gen[key](arg);
                var value = result.value;
                if (value instanceof AwaitValue) {
                    Promise.resolve(value.value).then(function (arg) {
                        resume('next', arg);
                    }, function (arg) {
                        resume('throw', arg);
                    });
                }
                else {
                    settle(result.done ? 'return' : 'normal', result.value);
                }
            }
            catch (err) {
                settle('throw', err);
            }
        }
        function settle(type, value) {
            switch (type) {
                case 'return':
                    front.resolve({
                        value: value,
                        done: true,
                    });
                    break;
                case 'throw':
                    front.reject(value);
                    break;
                default:
                    front.resolve({
                        value: value,
                        done: false,
                    });
                    break;
            }
            front = front.next;
            if (front) {
                resume(front.key, front.arg);
            }
            else {
                back = null;
            }
        }
        this._invoke = send;
        if (typeof gen.return !== 'function') {
            this.return = undefined;
        }
    }
    if (typeof Symbol === 'function' && Symbol.asyncIterator) {
        AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    AsyncGenerator.prototype.next = function (arg) {
        return this._invoke('next', arg);
    };
    AsyncGenerator.prototype.throw = function (arg) {
        return this._invoke('throw', arg);
    };
    AsyncGenerator.prototype.return = function (arg) {
        return this._invoke('return', arg);
    };
    return {
        wrap: function (fn) {
            return function () {
                return new AsyncGenerator(fn.apply(this, arguments));
            };
        },
        await: function (value) {
            return new AwaitValue(value);
        },
    };
})();
var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
};
var createClass = (function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
})();
/** A class for creating, managing, and destroying groupable content as tabs. */
var TabsLayout = (function () {
    function TabsLayout(groupedContent) {
        classCallCheck(this, TabsLayout);
        this.groupedContent = groupedContent;
        this.pairings = groupedContent.pairings;
        this.events = [];
        this._handleKeydown = this._handleKeydown.bind(this);
        this._handleClick = this._handleClick.bind(this);
        this._init();
        a11y.init(this.groupedContent);
    }
    createClass(TabsLayout, [
        {
            key: 'unload',
            value: function unload() {
                forEach(this.events, function (event) {
                    event.trigger.removeEventListener(event.type, event.fn);
                });
            },
        },
        {
            key: '_init',
            value: function _init() {
                var _this = this;
                var existingActive = false;
                forEach(this.pairings, function (pairing) {
                    var trigger = pairing.trigger;
                    if (hasClass(trigger, 'active')) {
                        existingActive = true;
                    }
                    trigger.addEventListener('keydown', _this._handleKeydown);
                    trigger.addEventListener('click', _this._handleClick);
                    _this.events.push({
                        trigger: trigger,
                        type: 'keydown',
                        fn: _this._handleKeydown,
                    });
                    _this.events.push({
                        trigger: trigger,
                        type: 'click',
                        fn: _this._handleClick,
                    });
                });
                if (!existingActive) {
                    addClass(this.pairings[0].trigger, 'active');
                    addClass(this.pairings[0].content, 'active');
                }
            },
        },
        {
            key: '_handleKeydown',
            value: function _handleKeydown(event) {
                var trigger = event.currentTarget;
                var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
                var pairingIndex = this.pairings.indexOf(pairing);
                var prevIndex = pairingIndex - 1 < 0 ? this.pairings.length - 1 : pairingIndex - 1;
                var nextIndex = pairingIndex + 1 >= this.pairings.length ? 0 : pairingIndex + 1;
                var nextPairing = null;
                switch (event.key) {
                    case 'ArrowLeft':
                        nextPairing = this.pairings[prevIndex];
                        break;
                    case 'ArrowRight':
                        nextPairing = this.pairings[nextIndex];
                        break;
                    default:
                        nextPairing = null;
                        break;
                }
                // Fast exit if we can't find the tab or tabs
                if (nextPairing === null)
                    return;
                event.preventDefault();
                forEach(this.pairings, function (inactivePairing) {
                    removeClass(inactivePairing.trigger, 'active');
                    removeClass(inactivePairing.content, 'active');
                });
                addClass(nextPairing.trigger, 'active');
                addClass(nextPairing.content, 'active');
                nextPairing.trigger.focus();
                a11y.update(this.groupedContent);
            },
        },
        {
            key: '_handleClick',
            value: function _handleClick(event) {
                var trigger = event.currentTarget;
                var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
                // Fast exit if we can't find the tab or tabs
                if (pairing === null)
                    return;
                event.preventDefault();
                forEach(this.pairings, function (inactivePairing) {
                    removeClass(inactivePairing.trigger, 'active');
                    removeClass(inactivePairing.content, 'active');
                });
                addClass(pairing.trigger, 'active');
                addClass(pairing.content, 'active');
                a11y.update(this.groupedContent);
            },
        },
    ]);
    return TabsLayout;
})();
function init$1(groupedContent) {
    var pairings = groupedContent.pairings;
    forEach(pairings, function (pairing, index) {
        pairing.trigger.setAttribute('role', 'button');
        pairing.trigger.setAttribute('aria-controls', groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content');
        pairing.trigger.setAttribute('tabIndex', '0');
        if (pairing.trigger.children.length > 0) {
            forEach(pairing.trigger.children, function (child) {
                child.setAttribute('tabIndex', '-1');
            });
        }
        if (hasClass(pairing.trigger, 'active')) {
            pairing.trigger.setAttribute('aria-expanded', 'true');
        }
        else {
            pairing.trigger.setAttribute('aria-expanded', 'false');
        }
        pairing.content.id = groupedContent.namespace + '-' + groupedContent.id + '-' + index + '-content';
        if (!hasClass(pairing.content, 'active')) {
            pairing.content.setAttribute('aria-hidden', 'true');
        }
    });
}
function update$1(groupedContent) {
    var pairings = groupedContent.pairings;
    forEach(pairings, function (pairing) {
        pairing.content.removeAttribute('aria-hidden');
        if (hasClass(pairing.trigger, 'active')) {
            pairing.trigger.setAttribute('aria-expanded', 'true');
        }
        else {
            pairing.trigger.setAttribute('aria-expanded', 'false');
        }
        if (!hasClass(pairing.content, 'active')) {
            pairing.content.setAttribute('aria-hidden', 'true');
        }
    });
}
var a11y$1 = {
    init: init$1,
    update: update$1,
};
/** A class for creating, managing, and destroying groupable content as an accordion. */
var AccordionLayout = (function () {
    function AccordionLayout(groupedContent) {
        classCallCheck(this, AccordionLayout);
        this.groupedContent = groupedContent;
        this.pairings = groupedContent.pairings;
        this.events = [];
        this._handleKeydown = this._handleKeydown.bind(this);
        this._handleClick = this._handleClick.bind(this);
        this._init(this.pairings);
        a11y$1.init(this.groupedContent);
    }
    createClass(AccordionLayout, [
        {
            key: 'unload',
            value: function unload() {
                forEach(this.events, function (event) {
                    event.trigger.removeEventListener(event.type, event.fn);
                });
            },
        },
        {
            key: '_init',
            value: function _init() {
                var _this = this;
                forEach(this.pairings, function (pairing) {
                    var trigger = pairing.trigger;
                    var content = pairing.content;
                    trigger.parentNode.insertBefore(content, trigger.nextSibling);
                    trigger.addEventListener('keydown', _this._handleKeydown);
                    trigger.addEventListener('click', _this._handleClick);
                    _this.events.push({
                        trigger: trigger,
                        type: 'keydown',
                        fn: _this._handleKeydown,
                    });
                    _this.events.push({
                        trigger: trigger,
                        type: 'click',
                        fn: _this._handleClick,
                    });
                });
                this.groupedContent.contents.remove();
            },
        },
        {
            key: '_handleKeydown',
            value: function _handleKeydown(event) {
                var trigger = event.currentTarget;
                var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
                // Fast exit if enter isn't pressed or we can't find the group
                if (event.key !== 'Enter' || pairing === null)
                    return;
                event.preventDefault();
                toggleClass(pairing.trigger, 'active');
                toggleClass(pairing.content, 'active');
                a11y$1.update(this.groupedContent);
            },
        },
        {
            key: '_handleClick',
            value: function _handleClick(event) {
                var trigger = event.currentTarget;
                var pairing = findPairingFromPairingTrigger(this.pairings, trigger);
                // Fast exit if we can't find the group
                if (pairing === null)
                    return;
                event.preventDefault();
                toggleClass(pairing.trigger, 'active');
                toggleClass(pairing.content, 'active');
                a11y$1.update(this.groupedContent);
            },
        },
    ]);
    return AccordionLayout;
})();
/**
 * Returns an array of nodes related to the heading node.
 * @param {node} heading - The heading node to search for content from.
 * @returns {node[]}
 */
function getHeadingContent(heading) {
    var headingTagNames = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
    var tagNameIndex = headingTagNames.indexOf(heading.tagName);
    var content = [];
    var sibling = heading.nextElementSibling;
    while (sibling !== null && (headingTagNames.indexOf(sibling.tagName) === -1 || headingTagNames.indexOf(sibling.tagName) > tagNameIndex)) {
        content.push(sibling);
        sibling = sibling.nextElementSibling;
    }
    return content;
}
/**
 * Returns an object array representing the heading tree from a given node.
 * Root nodes are evaluated differently, and requires the evaluatingRoot flag
 * to be true.
 * @param {node} el - The node being evaluated.
 * @param {node[]} children - The children of the evaluated node.
 * @param {boolean} [evaluatingRoot] - Whether to evaluate as root node.
 * @returns {Object[]}
 */
function getHeadingTree(el, children, evaluatingRoot = false) {
    var headingTagNames = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
    var tagNameIndex = headingTagNames.indexOf(el.tagName);
    var headings = [];
    var currentLowestTagNameIndex = 5;
    for (var i = 0; i < children.length; i += 1) {
        var child = children[i];
        var childTagNameIndex = headingTagNames.indexOf(child.tagName);
        if (childTagNameIndex !== -1 && childTagNameIndex < currentLowestTagNameIndex) {
            currentLowestTagNameIndex = childTagNameIndex;
        }
        if ((evaluatingRoot && childTagNameIndex !== -1 && childTagNameIndex <= currentLowestTagNameIndex) ||
            (!evaluatingRoot && childTagNameIndex !== -1 && childTagNameIndex === tagNameIndex + 1)) {
            var siblings = getHeadingContent(child);
            var childNode = {
                el: child,
                content: siblings,
                children: getHeadingTree(child, siblings),
            };
            headings.push(childNode);
        }
    }
    return headings;
}
/**
 * Returns groupings of headings that meet the minimum sequence value
 * and don't contain any invalid headings.
 * @param {Object[]} headings - An array of heading objects.
 * @param {int[]} invalidHeadings - An array of invalid heading integers,
 *                                  representing indexes of headings.
 * @param {*} minInSequence - Minimum headings in sequence before being considered
 *                            as a grouping.
 * @returns {Object[][]}
 */
function getHeadingGroupsInSequence(headings, invalidHeadings, minInSequence) {
    var headingGroupsInSequence = [];
    var currentHeadingGroupInSequence = [];
    var currentSequence = 0;
    for (var i = 0; i < headings.length; i += 1) {
        if (invalidHeadings.indexOf(i) === -1) {
            currentHeadingGroupInSequence.push(headings[i]);
            currentSequence += 1;
            if (i !== headings.length - 1 && headings[i].el.tagName !== headings[i + 1].el.tagName && invalidHeadings.indexOf(i + 1)) {
                currentHeadingGroupInSequence = [];
                currentSequence = 0;
            }
            else if (i !== 0 && headings[i].el.tagName !== headings[i - 1].el.tagName) {
                currentHeadingGroupInSequence.pop();
                currentSequence -= 1;
                if (currentSequence >= minInSequence) {
                    headingGroupsInSequence.push(currentHeadingGroupInSequence);
                }
                currentHeadingGroupInSequence = [headings[i]];
                currentSequence = 1;
            }
        }
    }
    if (currentSequence >= minInSequence) {
        headingGroupsInSequence.push(currentHeadingGroupInSequence);
    }
    return headingGroupsInSequence;
}
/**
 * Generates necessary DOM elements to group related content.
 * Returns a object array representing the grouped content.
 * @param {Object[]} children - An array of objects.
 * @returns {Object[]}
 */
function createGroupedContent(children) {
    var pairings = [];
    var firstChild = children[0].el;
    var triggers = document.createElement('div');
    var contents = document.createElement('div');
    contents = firstChild.parentNode.insertBefore(contents, firstChild.nextSibling);
    triggers = firstChild.parentNode.insertBefore(triggers, firstChild.nextSibling);
    for (var i = 0; i < children.length; i += 1) {
        var child = children[i];
        var trigger = child.el;
        var content = document.createElement('div');
        trigger = triggers.appendChild(trigger);
        content = contents.appendChild(content);
        for (var j = 0; j < child.content.length; j += 1) {
            content.appendChild(child.content[j]);
        }
        pairings.push({
            trigger: trigger,
            content: content,
        });
    }
    return {
        triggers: triggers,
        contents: contents,
        pairings: pairings,
    };
}
/**
 * Returns all groupable content within the supplied node.
 * @param {node} node - A node to traverse for groupable content.
 * @returns {Object[][]}
 */
/*
 * Recursive function:
 *  Returns all groups of headings that
 *  are elegible to become grouped content.
 */
function getGroupedContentSet(node) {
    var children = node.children;
    var childrenWithGroupableContent = [];
    var groupedContentSet = [];
    if (children.length === 0) {
        return [];
    }
    for (var i = 0; i < children.length; i += 1) {
        var childGroupableContent = getGroupedContentSet(children[i]);
        if (childGroupableContent.length > 0) {
            childrenWithGroupableContent.push(i);
            groupedContentSet = groupedContentSet.concat(childGroupableContent);
        }
    }
    var headingGroupsInSequence = getHeadingGroupsInSequence(children, childrenWithGroupableContent, 3);
    for (var _i = 0; _i < headingGroupsInSequence.length; _i += 1) {
        groupedContentSet.push(createGroupedContent(headingGroupsInSequence[_i]));
    }
    return groupedContentSet;
}
/**
 * When static parsing isn't enough, there's intelliparse™!
 * Searches through dom content to find heading groupings that
 * are elegible to become tab groups.
 * Assumes that content is in a flattened hierarchy in the dom
 * and interprets increasing heading values as a deeper level of nesting.
 * Returns all groupable content as an array of object arrays.
 * @param {node} el - The node who's content will be searched for groupable content.
 * @returns {Object[][]}
 */
function intelliParse(el) {
    var children = el.children;
    var heading = el.querySelector('h1, h2, h3, h4, h5, h6');
    // Fast return if there's no headings
    if (children.length === 0)
        return [];
    var rootNode = {
        el: el,
        content: null,
        children: getHeadingTree(heading, children, true),
    };
    return getGroupedContentSet(rootNode);
}
/**
 * Parses content from a given node based on a static structure.
 * The structure is as follows:
 * <ul class="tabs">
 *   <li class="active">Tab 1</li>
 *   <li>Tab 2</li>
 *   <li>Tab 3</li>
 * </ul>
 *
 * <ul class="tabs-content">
 *   <li class="active">
 *     <p>Tab 1 content goes here.</p>
 *   </li>
 *   <li>
 *     <p>Tab 2 content goes here.</p>
 *   </li>
 *   <li>
 *     <p>Tab 3 content goes here.</p>
 *   </li>
 * </ul>
 * Returns all groupable content as an array of object arrays.
 * @param {node} el - The node who's content will be searched for groupable content.
 * @returns {Object[][]}
 */
function staticParse(el) {
    var groupedContentSet = [];
    var tabs = el.querySelectorAll('.tabs');
    for (var i = 0; i < tabs.length; i += 1) {
        var triggers = tabs[i].children;
        var contents = tabs[i].nextElementSibling.children;
        // Only add a tab group if equal triggers to contents
        if (triggers.length === contents.length) {
            var length = groupedContentSet.push({
                triggers: tabs[i],
                contents: tabs[i].nextElementSibling,
                pairings: [],
            });
            var index = length - 1;
            for (var j = 0; j < triggers.length; j += 1) {
                var trigger = triggers[j];
                var content = contents[j];
                var pairing = {
                    trigger: trigger,
                    content: content,
                };
                groupedContentSet[index].pairings.push(pairing);
            }
        }
    }
    return groupedContentSet;
}
/**
 * Returns all groupable content as an array of object arrays.
 * @param {node} content - The node to parse for groupable content.
 * @param {boolean} intelliparse - Whether to use intelligent parsing.
 * @returns {Object[][]}
 */
function parse(content, intelliparse = false) {
    var groupedContentSet = intelliparse ? intelliParse(content) : staticParse(content);
    return groupedContentSet;
}
/** A class for creating, managing, and destroying groupable content. */
var GroupedContent = (function () {
    /**
     * Create grouped content
     * @param {node} el - The element to search for groupable content in.
     * @param {Object}  [options] - Additional options
     * @param {string}  [options.layout] - The layout to display groupable content in.
     * @param {boolean} [options.intelliparse] - The parsing algorithm used to find content with.
     */
    function GroupedContent(el, options = {}) {
        var _this = this;
        classCallCheck(this, GroupedContent);
        this.namespace = 'grouped-content';
        this.el = el;
        this.groupedContentInstances = [];
        var layout = options.layout || 'tabs';
        var intelliparse = !!options.intelliparse;
        forEach(parse(el, intelliparse), function (groupedContent) {
            var id = uuidv4();
            var instance = null;
            var groupedContentWrapper = document.createElement('div');
            groupedContentWrapper = groupedContent.triggers.parentNode.insertBefore(groupedContentWrapper, groupedContent.triggers.nextSibling);
            addClass(groupedContentWrapper, _this.namespace);
            addClass(groupedContentWrapper, _this.namespace + '-layout-' + layout);
            groupedContentWrapper.appendChild(groupedContent.triggers);
            groupedContentWrapper.appendChild(groupedContent.contents);
            groupedContent.namespace = _this.namespace;
            groupedContent.id = id;
            groupedContent.triggers.id = _this.namespace + '-' + id + '-triggers';
            groupedContent.contents.id = _this.namespace + '-' + id + '-contents';
            addClass(groupedContent.triggers, _this.namespace + '-triggers');
            addClass(groupedContent.contents, _this.namespace + '-contents');
            forEach(groupedContent.pairings, function (pairing) {
                addClass(pairing.trigger, _this.namespace + '-trigger');
                addClass(pairing.content, _this.namespace + '-content');
            });
            switch (layout) {
                case 'accordion':
                    instance = new AccordionLayout(groupedContent);
                    break;
                case 'tabs':
                default:
                    instance = new TabsLayout(groupedContent);
                    break;
            }
            _this.groupedContentInstances.push({
                groupedContent: groupedContent,
                instance: instance,
            });
        });
    }
    /** Unload all grouped content instances */
    createClass(GroupedContent, [
        {
            key: 'unload',
            value: function unload() {
                forEach(this.groupedContentInstances, function (groupedContentInstance) {
                    groupedContentInstance.instance.unload();
                });
            },
        },
    ]);
    return GroupedContent;
})();
export default GroupedContent;
